import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import { useInvoicePrintTheme } from "hooks/useInvoicePrintTheme";
import { usePaletteMode } from "hooks/usePaletteMode";

const InvoicePrintThemeToggle = ({ size = "small" }) => {
  const paletteMode = usePaletteMode();
  const { darkPrint, setDarkPrint } = useInvoicePrintTheme();

  if (paletteMode !== "dark") {
    return null;
  }

  return (
    <Tooltip title="Light PDF is the default for invoices and payslips. Enable for dark-styled print/download.">
      <FormControlLabel
        control={
          <Switch
            size={size}
            checked={darkPrint}
            onChange={(event) => setDarkPrint(event.target.checked)}
          />
        }
        label="Dark PDF"
        sx={{
          mr: 0,
          ml: 0,
          "& .MuiFormControlLabel-label": { fontSize: 13, whiteSpace: "nowrap" },
        }}
      />
    </Tooltip>
  );
};

export default InvoicePrintThemeToggle;
